import PermissionRoles from '../../../../StaticData/Roles/Permission';
import isAny from '../../../../Common/Utils/Any';

const CheckSystemPermission = (permissions, component) => {
  if (permissions && isAny(permissions.permission_roles, PermissionRoles.SYSTEM_CAMPAIGN_SETTINGS)) {
    return component;
  } else {
    return null;
  }
}

export default CheckSystemPermission;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Helpers/CheckSystemPermission.tsx